import { BrowserRouter } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import { ErrorBoundary } from 'react-error-boundary';
import { generateTheme } from '@cld/theme-helper';
import GlobalStyle from '@cld/global-style';
import { SessionServiceProvider, PLATFORM_APP } from '@cld/session-service';
import { AccountSettings } from './AccountSettings';
import { CloudinaryFavicon } from './components/CloudinaryFavicon/CloudinaryFavicon';
import {
  CustomerIdProviderWithSession,
  UserDataProvider,
  UnicornWrapper,
} from '@cld-remote/application_wrapper/index';
import { ServerError } from '@cld/empty-state';
import { ProgressSpinner } from './components/ProgressSpinner/ProgressSpinner';
import { AppContextConnected } from './context/App.context.js';

const StyledApp = styled.div`
  background-color: ${(props) => props.theme.palette.contrastInvert};
  height: 100vh;
`;

export const App = () => (
  <ThemeProvider theme={generateTheme()}>
    <GlobalStyle />
    <CloudinaryFavicon />
    <ErrorBoundary FallbackComponent={() => <ServerError />}>
      <SessionServiceProvider appId={PLATFORM_APP}>
        <UnicornWrapper>
          {(apiState) => {
            return (
              <StyledApp>
                {apiState.status === 'ready' && (
                  <CustomerIdProviderWithSession>
                    <UserDataProvider unicornApi={apiState.api}>
                      {/*          /!*Temporary, getting MPE_BASE_DIRECTORY does not work with module federation *!/*/}
                      {/*          /!*Jira ticket: https://cloudinary.atlassian.net/browse/INFRA-5600*!/*/}
                      <BrowserRouter basename="/settings">
                        <AppContextConnected unicornApi={apiState.api}>
                          <AccountSettings unicornApi={apiState.api} />
                        </AppContextConnected>
                      </BrowserRouter>
                    </UserDataProvider>
                  </CustomerIdProviderWithSession>
                )}
                {apiState.status === 'loading' && <ProgressSpinner size="xxl" />}
                {apiState.status === 'error' && <ServerError />}
              </StyledApp>
            );
          }}
        </UnicornWrapper>
      </SessionServiceProvider>
    </ErrorBoundary>
  </ThemeProvider>
);
